import { createContext, useReducer } from 'react'

const initValues = {
  auth: false,
  user: '',
  permissions: [],
  accountActions: {
    doLogin: null,
    doLogout: null,
  },
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'setAuthState': {
      return {
        ...state,
        auth: action.auth,
      }
    }
    case 'doLogout': {
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('refreshExp')
      localStorage.removeItem('token')
      localStorage.removeItem('tokenExp')
      return {
        ...state,
        auth: false,
      }
    }
    case 'setAccountActions': {
      return {
        ...state,
        accountActions: {
          doLogin: action.doLogin,
          dologout: action.doLogout,
        },
      }
    }
    default: {
      return state
    }
  }
}

const AuthContext = createContext(null)

export const AuthWrapper = props => {
  const [state, dispatch] = useReducer(reducer, initValues)

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthContext
